import { FunctionComponent, useState } from 'react';
import { type Automation } from '@spike/automation-model';
import { Table } from 'components/UI/V3/Table/Table';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import AutomationsRow from './AutomationsRow';
import styles from './AutomationsTable.module.scss';

interface Props {
    automations: Automation[];
    isLoading?: boolean;
    onEdit?: (automation: Automation) => void;
    onDelete?: (automation: Automation) => void;
    onToggleStatus?: (automation: Automation) => void;
}

const AutomationsTable: FunctionComponent<Props> = ({ automations, isLoading, onEdit, onDelete, onToggleStatus }) => {
    const [openDropdownId, setOpenDropdownId] = useState<string | null>(null);

    return (
        <Table
            pagination={{ page: 1, totalPages: 1, size: automations.length, isLoading: isLoading ?? false }}
            className={styles.table}
            wrapperClassName={styles.scrollWrapper}
            fullHeight
        >
            <TableHeader className={styles.tableHeader}>
                <TableHeaderCell>Name</TableHeaderCell>
                <TableHeaderCell>Status</TableHeaderCell>
                <TableHeaderCell>Trigger</TableHeaderCell>
                <TableHeaderCell>Created</TableHeaderCell>
                <TableHeaderCell>Last Updated</TableHeaderCell>
                <TableHeaderCell></TableHeaderCell>
            </TableHeader>

            <TableBody>
                {automations.map((automation, index) => (
                    <AutomationsRow
                        key={automation.id}
                        automation={automation}
                        isLast={index === automations.length - 1}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        onToggleStatus={onToggleStatus}
                        isDropdownOpen={openDropdownId === automation.id}
                        onDropdownToggle={isOpen => setOpenDropdownId(isOpen ? automation.id : null)}
                    />
                ))}
            </TableBody>
        </Table>
    );
};

export default AutomationsTable;
